import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'view-all-launch-product',
    children: [{ id: SectionsKey.ViewAllLaunchProduct, order: 1 }]
};

export default PageStruct;
